import { Text } from '@wartek-id/text-v1'

import { Alert } from 'components/Alert'

const SearchNotice = () => {
  return (
    <Alert color="gray" icon="info" className="mt-2 text-black">
      <Text variant="body-sm">
        Ketik keterangan spesifik—<b>kelas, video, nama materi, dll</b>
        —untuk hasil lebih akurat.
      </Text>
    </Alert>
  )
}

export default SearchNotice
